var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.Base)?_c(_vm.Base,{tag:"component",attrs:{"contractData":_vm.contractData}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }